import React from 'react'
import { Button } from './styles'

const ButtonComponent = ({ children, ...rest }) => (
  <Button {...rest}>{children}</Button>
)

export default ButtonComponent
